// Enums
export enum ArenaLockAction {
  LOCK = "lock",
  UNLOCK = "unlock",
}

export enum ConfigurationType {
  DEFAULT = "default",
  CUSTOM = "custom",
}

export enum UploadState {
  IDLE = "idle",
  UPLOADING = "uploading",
  UPLOADED = "uploaded",
  TRIGGERING = "triggering",
  SUCCESS = "success",
  ERROR = "error",
}

export enum ArenaLockToolId {
  LOCK = "arena_lock",
  UNLOCK = "arena_unlock",
}

// Default configuration paths for GraphQL API (relative paths only)
export const DEFAULT_CONFIG_PATHS: Record<ArenaLockAction, string> = {
  [ArenaLockAction.LOCK]:
    "JSQ_DATA_STUDIO_DEFAULT_CONFIGS/ARENA_LOCK_UNLOCK_CONFIGS/user_entity_file_FA_lock.txt",
  [ArenaLockAction.UNLOCK]:
    "JSQ_DATA_STUDIO_DEFAULT_CONFIGS/ARENA_LOCK_UNLOCK_CONFIGS/user_entity_file_FA_unlock.txt",
};

// File size limit: 10MB
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const ENVIRONMENT_OPTIONS = [
  { value: "test", label: "Test" },
  { value: "production", label: "Production" },
];
